var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatWeDoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 89,
    viewBox: "0 0 86 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4526 81.6033L85.9785 66.1327L70.4963 21.6108L61.4637 24.7499L71.974 54.9697L5.83987 20.8137L2.00839 28.2323L68.0876 62.36L38.3549 72.69L41.4526 81.6033Z",
    fill: "#051A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDoArrow);
export default __webpack_public_path__ + "static/media/whatWeDoArrow.496b8cb5ba8ce7fbd64e5d5b45512631.svg";
export { ForwardRef as ReactComponent };